import BaseEntityService from "core/framework/BaseEntityService";

export default class BaseFileService extends BaseEntityService {
  constructor({ baseUrl }) {
    super({ baseUrl });
  }

  async getUnsatisfiedTagAlternatives(instance) {
    if (!instance) {
      //log.error("Missing parameter: instance");
      throw Error("Missing parameter: instance");
    }

    return await this.post({
      url: this.baseUrl + "/unsatisfied",
      data: instance
    });
  }
}
